/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type CreateServiceAccountAuthServiceAccountsResponse429ResponseBodyData =
  {
    message: string;
  };

/**
 * Rate limited
 */
export class CreateServiceAccountAuthServiceAccountsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateServiceAccountAuthServiceAccountsResponse429ResponseBodyData;

  constructor(
    err: CreateServiceAccountAuthServiceAccountsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "CreateServiceAccountAuthServiceAccountsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type CreateServiceAccountAuthServiceAccountsResponse409ResponseBodyData =
  {
    message: string;
  };

/**
 * Conflict
 */
export class CreateServiceAccountAuthServiceAccountsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateServiceAccountAuthServiceAccountsResponse409ResponseBodyData;

  constructor(
    err: CreateServiceAccountAuthServiceAccountsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "CreateServiceAccountAuthServiceAccountsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type CreateServiceAccountAuthServiceAccountsResponse404ResponseBodyData =
  {
    message: string;
  };

/**
 * Not found
 */
export class CreateServiceAccountAuthServiceAccountsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateServiceAccountAuthServiceAccountsResponse404ResponseBodyData;

  constructor(
    err: CreateServiceAccountAuthServiceAccountsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "CreateServiceAccountAuthServiceAccountsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type CreateServiceAccountAuthServiceAccountsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class CreateServiceAccountAuthServiceAccountsResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateServiceAccountAuthServiceAccountsResponseResponseBodyData;

  constructor(
    err: CreateServiceAccountAuthServiceAccountsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateServiceAccountAuthServiceAccountsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type CreateServiceAccountAuthServiceAccountsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class CreateServiceAccountAuthServiceAccountsResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: CreateServiceAccountAuthServiceAccountsResponseBodyData;

  constructor(
    err: CreateServiceAccountAuthServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateServiceAccountAuthServiceAccountsResponseBody";
  }
}

/**
 * Bad request
 */
export type CreateServiceAccountResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class CreateServiceAccountResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateServiceAccountResponseBodyData;

  constructor(
    err: CreateServiceAccountResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateServiceAccountResponseBody";
  }
}

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateServiceAccountAuthServiceAccountsResponse429ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type CreateServiceAccountAuthServiceAccountsResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateServiceAccountAuthServiceAccountsResponse429ResponseBody
  > = z.instanceof(
    CreateServiceAccountAuthServiceAccountsResponse429ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateServiceAccountAuthServiceAccountsResponse409ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type CreateServiceAccountAuthServiceAccountsResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateServiceAccountAuthServiceAccountsResponse409ResponseBody
  > = z.instanceof(
    CreateServiceAccountAuthServiceAccountsResponse409ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateServiceAccountAuthServiceAccountsResponse404ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type CreateServiceAccountAuthServiceAccountsResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateServiceAccountAuthServiceAccountsResponse404ResponseBody
  > = z.instanceof(
    CreateServiceAccountAuthServiceAccountsResponse404ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponseResponseBody$inboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateServiceAccountAuthServiceAccountsResponseResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type CreateServiceAccountAuthServiceAccountsResponseResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponseResponseBody$outboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    CreateServiceAccountAuthServiceAccountsResponseResponseBody
  > = z.instanceof(CreateServiceAccountAuthServiceAccountsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponseBody$inboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new CreateServiceAccountAuthServiceAccountsResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type CreateServiceAccountAuthServiceAccountsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateServiceAccountAuthServiceAccountsResponseBody$outboundSchema:
  z.ZodType<
    CreateServiceAccountAuthServiceAccountsResponseBody$Outbound,
    z.ZodTypeDef,
    CreateServiceAccountAuthServiceAccountsResponseBody
  > = z.instanceof(CreateServiceAccountAuthServiceAccountsResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateServiceAccountResponseBody$inboundSchema: z.ZodType<
  CreateServiceAccountResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new CreateServiceAccountResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type CreateServiceAccountResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateServiceAccountResponseBody$outboundSchema: z.ZodType<
  CreateServiceAccountResponseBody$Outbound,
  z.ZodTypeDef,
  CreateServiceAccountResponseBody
> = z.instanceof(CreateServiceAccountResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
